import { useRouteError, useNavigate } from 'react-router-dom';

export default function RouteErrorFallback() {
  const error = useRouteError();
  const navigate = useNavigate();

  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : 'An unexpected error occurred.';

  // Log the full error for debugging (source maps will make this readable)
  console.error('Route error:', error);

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-lg">
        <div className="text-4xl">😵</div>
        <h1 className="mt-4 text-xl font-bold text-gray-900">
          Something went wrong
        </h1>
        <p className="mt-2 text-sm text-gray-500">{message}</p>
        <div className="mt-6 flex gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="rounded-xl border-2 border-gray-200 px-6 py-3 font-semibold text-gray-600 hover:bg-gray-50"
          >
            Go Back
          </button>
          <button
            onClick={() => window.location.reload()}
            className="rounded-xl bg-brand-500 px-6 py-3 font-semibold text-white hover:bg-brand-600"
          >
            Reload
          </button>
        </div>
      </div>
    </div>
  );
}
